
<div class="body-inner">
  <textarea
    ref="emoji_textarea"
    v-model="textValue"
    :name="name"
    :cols="cols"
    :rows="rows"
    class="body-textarea"
    :placeholder="placeholder"
  />

  <app-label-text
    class="body-counter"
    :title="counter"
  />

  <emoji-picker @emoji="insert">
    <div
      slot="emoji-invoker"
      slot-scope="{ events: { click: clickEvent } }"
      class="emoji"
      @click.stop="clickEvent"
    >
      <div
        id="btn-trigger"
        class="emoji-icon"
      >
        <i
          class="fa fa-smile-o fa-2x active"
          aria-hidden="true"
        />
      </div>
    </div>
    <div
      slot="emoji-picker"
      slot-scope="{ emojis, insert }"
      class="emoji-inner"
    >
      <div
        v-for="(emojiGroup, category) in emojis"
        :key="category"
      >
        <div class="l_emoji_list">
          <span
            v-for="(emoji, emojiName) in emojiGroup"
            :key="emojiName"
            :title="emojiName"
            @click="insert(emoji)"
          >
            {{ emoji }}
          </span>
        </div>
      </div>
    </div>
  </emoji-picker>
</div>
